import * as Yup from 'yup';

const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

const DroneProfileSchema = (t: (key: string) => string) =>
  Yup.object().shape({
    name: Yup.string().required(t('signup_page.errors.required')),
    drone_model: Yup.string().required(t('signup_page.errors.required')),
    device_uuid: Yup.string()
      .required(t('signup_page.errors.required'))
      .matches(uuidRegex, t('drone_profiles.errors.invalid_uuid'))
  });

export default DroneProfileSchema;
